import ButtonCustom from "../../../../../../../components/Button";
import React, { useState, useContext, useEffect } from "react";
import { LocalizationContext } from "../../../../../../../locales/Translation";
import SizeBox from "../../../../../../../components/SizeBox";
import EditActions from "./EditActions";
import { useDispatch, useSelector } from "react-redux";
import {
  propertyDetailSelector,
  timeZoneListSelector,
} from "../../../../../selectors/PropertySelector";
import ScheduleTable from "./ScheduleTable";
import ScheduleList from "./ScheduleList";
import { OPERATION_HOUR_INIT } from "../../../../../../App/configs/DateTimeConfigs";
import {
  onInheritScheduleAction,
  updatePropertyService,
} from "../../../../../services/PropertyServices";
import {
  getPropertyDetailThunk,
  getTimeZoneListThunk,
} from "../../../../../thunks/PropertyThunks";
import { toastError } from "../../../../../../../components/Toast";
import { useParams } from "react-router-dom";
import { DropdownProps } from "semantic-ui-react";
import DropdownCustom from "../../../../../../../components/DropdownCustom";
import { GET_TIMEZONE_LIST_ACTION } from "../../../../../configs/Actions";
import DropdownSearchAndPaging from "../../../../../../../components/DropdownSearchAndPaging";

const PropertyTimeZone = ({ setLoading, loading }: any) => {
  const [tabIndex, setTabIndex] = useState(1);
  const { translations } = useContext(LocalizationContext);
  const [editMode, setEditMode] = useState(false);
  const propertyDetail = useSelector(propertyDetailSelector);
  const timeZoneList = useSelector(timeZoneListSelector);
  const [selectedTimeZone, setSelectedTimeZone] = useState(null);
  const { id } = useParams();
  const dispatch = useDispatch();

  const _handleSave = async () => {
    const payload = {
      timezone: selectedTimeZone,
      property_id: id,
    };
    setLoading(true);
    try {
      await updatePropertyService(payload);
      await dispatch<any>(getPropertyDetailThunk(id ? id : ""));
      setEditMode(false);
    } catch (response: any) {
      toastError(response?.status?.message);
    } finally {
      setLoading(false);
    }
  };
  const timezoneOptions = Object.entries(timeZoneList).map(([key, value]) => ({
    key,
    text: value || "No timezone",
    value,
  }));
  useEffect(() => {
    dispatch<any>(getTimeZoneListThunk({}));
  }, [dispatch]);
  const handleChange = (event: any, { value }: any) => {
    setSelectedTimeZone(value);
  };
  return (
    <>
      <div
        className={"flex-1 pr-38 border-right-1 property-schedule__wrapper"}
        style={{ marginTop: 17, marginBottom: 36 }}
      >
        <div
          className={
            "d-flex justify-content-between flex-1 " +
            (editMode ? "" : "align-items-center")
          }
        >
          <div className={"section-title"} style={{ lineHeight: "37px" }}>
            Timezone
            {/*    translations.timezone*/}
          </div>
          <EditActions
            editMode={editMode}
            setEditMode={setEditMode}
            submit={_handleSave}
            loading={loading}
          />
        </div>
        <SizeBox height={"5px"} className={"d-sm-none"} />

        {editMode ? (
          <>
            <div style={{ width: "100%", marginTop: 10 }}>
              <DropdownSearchAndPaging
                placeholder="Select timezone"
                options={timezoneOptions}
                value={selectedTimeZone}
                onChange={handleChange}
                listCompanyRaw={timeZoneList}
                selectUI={true}
              />
            </div>
          </>
        ) : (
          <div style={{ marginLeft: 10 }}>{propertyDetail.timezone}</div>
        )}
      </div>
    </>
  );
};

export default PropertyTimeZone;
